var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSchluessel = function SvgSchluessel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.205,
    height: 77.036
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M20.305 39.094h2.193v37.942h-2.193zM15.868 39.094v37.942l-3.884-2.756 1.08-2.87-1.078-3.003.002-4.36 1.938-4.456-1.935-3.584 1.023-3.019-1.021-3.48.003-8.195.002-2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M37.153 18.577A18.577 18.577 0 1 0 9.48 34.775q.075.043.149.084v6.454h2.368l.002-2.22h3.87v37.943h4.437V39.094h2.193v37.942l2.378-3.435V41.313h2.65V34.86q.075-.041.149-.084a18.57 18.57 0 0 0 9.478-16.198M18.577 33.982a15.406 15.406 0 1 1 15.405-15.405 15.423 15.423 0 0 1-15.405 15.405"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M18.576 3.17a15.406 15.406 0 1 0 15.406 15.407A15.423 15.423 0 0 0 18.576 3.17m0 11.788a4.308 4.308 0 1 1 4.309-4.308 4.313 4.313 0 0 1-4.309 4.308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M68.357 0h2.193v37.942h-2.193zM63.92 37.942V0l-3.884 2.756 1.08 2.87-1.078 3.003.002 4.359 1.938 4.457-1.935 3.584 1.023 3.019-1.021 3.48.004 8.195.001 2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M85.205 58.46a18.577 18.577 0 1 1-27.674-16.2l.149-.083v-6.454h2.369l.001 2.22h3.87V0h4.437v37.942h2.193V0l2.378 3.435v32.288h2.65v6.454q.075.041.149.084a18.57 18.57 0 0 1 9.478 16.198M66.63 43.053a15.406 15.406 0 1 0 15.405 15.405A15.423 15.423 0 0 0 66.63 43.054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M66.629 73.865A15.406 15.406 0 1 1 82.034 58.46 15.423 15.423 0 0 1 66.63 73.865m0-11.787a4.308 4.308 0 1 0 4.308 4.308 4.313 4.313 0 0 0-4.308-4.308"
  }))));
};
export default SvgSchluessel;